//import { useEffect } from 'react';

import { useEffect } from 'react';

import { Route, Routes, useNavigate } from 'react-router-dom';

import { getEnvVariable } from '@appcharge/shared-ui';
import { useLogin } from 'hooks/useLogin';

import ConfirmationPage from './ConfirmationPage';
import SignUpPage from './SignUpPage';

const SignUpView = () => {
  const navigate = useNavigate();
  const { isLoggedIn } = useLogin();

  useEffect(() => {
    if (getEnvVariable('REACT_APP_ENV') === 'production' || isLoggedIn()) {
      navigate('/', { replace: true });
    }
  }, [isLoggedIn, navigate]);

  return (
    <Routes>
      <Route path="/" element={<SignUpPage />} />
      <Route path="/confirmation" element={<ConfirmationPage />} />
    </Routes>
  );
};

export default SignUpView;
